module.exports = __webpack_public_path__ + "img/2.ed7f3b23.png";